<template>
  <div class="bg-gray-50 p-8 rounded-lg">
    <h3 class="text-2xl font-bold mb-6">Program Benefits</h3>
    <ul class="grid grid-cols-1 md:grid-cols-2 gap-4">
      <li 
        v-for="point in bulletPoints" 
        :key="point" 
        class="flex items-start"
      >
        <span class="text-green-600 mr-2">✓</span>
        {{ point }}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'ProgramBenefits',
  props: {
    bulletPoints: {
      type: Array,
      required: true
    }
  }
}
</script> 